/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { CardBody, Badge } from 'reactstrap';
import { connect } from 'react-redux';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import ProIcon from 'mdi-react/AccountStarIcon';
import ArrowRightIcon from 'mdi-react/ArrowRightDropCircleIcon';
import ArrowLeftIcon from 'mdi-react/ArrowLeftDropCircleIcon';
import moment from 'moment';
import Slider from 'react-slick';

import { 
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_nameToUrl,
	_shouldShow,
	_getBuildingURL,
	buildingFL,
	_replaceAbbreviations,
	StatusBadge,
	_getUnitFloorPlan
} from "../../../../shared/helpers/utils";
import { height } from '@material-ui/system';


const Sale = `${process.env.PUBLIC_URL}/img/for_store/catalog/sale_lable.png`;
const New = `${process.env.PUBLIC_URL}/img/for_store/catalog/new_lable.png`;

const SliderItems = (props) => {


    const { items, user, toggleModal , icon, color, setLayoutStyle, setIsHeaderAvailable, setIsFooterAvailable, setReportItem, setSubmit,  setIsBuilding, setIsMedia} = props;
    const settings = {
		  dots: false,
		  infinite: false,
		  speed: 500,
		  autoplay: false,
		  swipeToSlide: true,
		  prevArrow: <ArrowLeftIcon size={30} fill="#000" />,
		  nextArrow: <ArrowRightIcon  size={30} fill="#000" />,
		  responsive: [
			{ breakpoint: 768, settings: { slidesToShow: 1 } },
		    { breakpoint: 992, settings: { slidesToShow: 2 } },
		    { breakpoint: 1200, settings: { slidesToShow: 4 } },
		    { breakpoint: 1536, settings: { slidesToShow: 4 } },
		    { breakpoint: 100000, settings: { slidesToShow: 4 } },
		  ],
	  };

   

    return (
      <div className="catalog-items_small catalog-items__wrap">
        <div className="catalog-items marketing-items">
          <Slider {...settings} className="">
          {items.map((item, i) => {
            const modifiedIconString = item.svgIcon
            ? item.svgIcon
               
            : `<svg viewBox="0 0 16 16" width="50" height="50" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M1 5V3L8 0L15 3V5L8 8L1 5Z" fill="#000000"></path> <path d="M8 16L1 13V11L8 14L15 11V13L8 16Z" fill="#000000"></path> <path d="M1 9L8 12L15 9V7L8 10L1 7V9Z" fill="#000000"></path> </g></svg>`;
            
            const modifiedIcon = modifiedIconString.replace(/fill=['"][^'"]*['"]/g, `fill="${item.cardColor ? item.cardColor : "#A3ADC2"}"`)
            .replace(/width=['"][^'"]*['"]/g, `width="50"`)
            .replace(/height=['"][^'"]*['"]/g, `height="50"`)
            
            return (<CardBody style={{ 
              backgroundColor: item.cardBackgroundColor ? `${item.cardBackgroundColor} !important` : '#fff', 
              padding: '10px !important', // Add other styles as necessary
              borderTop: `2px solid ${item.cardColor ? item.cardColor : "#A3ADC2"}`
            }}  key={i} onClick={() => {
              
              if(item.reportComponent){
                console.log(item, "myItem")
                toggleModal(item.reportComponent)}
                setLayoutStyle(item.style? {...item.style}:null);

                setIsHeaderAvailable(item.hasOwnProperty("Header") ? item.Header : true);

                setIsFooterAvailable(item.hasOwnProperty("Footer")? item.Footer:true);
                setReportItem(item);
                
                item.isMedia && setIsMedia&& setIsMedia(true);
                setSubmit(true);
                setIsBuilding &&  item.isBuilding && setIsBuilding(item.isBuilding)
                
              }
              } >
              <div className={`catalog-item marketing-center-item ${!item.reportComponent ? 'coming_soon' : ''}`}
                // style={{borderBottom: `2px solid ${item.cardColor ? item.cardColor : "#A3ADC2"}`}}
              >
                {modifiedIcon && <div className="svg" dangerouslySetInnerHTML={{ __html: modifiedIcon }} />}
             
                <div className="item-image" style={{backgroundImage:`url(${item.img})`}}>
                
                  	
                   
                </div>
                {/* <h4 className="" style={{backgroundColor:item.cardColor ? item.cardColor : "#A3ADC2"}}>
                                   		
                 </h4> */}
               <h4>
                 {_capitalizeText(item.name.slice(0, item.name.lastIndexOf(' ')))}{' '}
                 <br/><strong>{_capitalizeText(item.name.split(' ').pop())}</strong>
               </h4>

                <div className="customize">
                    <button style={{backgroundColor:item.cardColor ? item.cardColor : "#A3ADC2"}}>{!item.reportComponent ? "Coming Soon" : "Preview & Customize"}</button>
                   
                </div>
                <div className="info-container">
                   
                   {/* {!item.reportComponent ? <h5 style={{fontWeight:600}}>-COMING SOON-</h5> : null} */}
                   {item.line1 ? 
                     <h6 className="mt-1">{item.line1}</h6>
                     :null
                    }
                    {item.line2 ? 
                     <h7>{item.line2}</h7>
                     :null
                    }
                  <p className="mt-2">{item.description} </p>
                 </div>             
                </div>
            </CardBody>)
          })}
           </Slider>
        </div>
      </div>
    );
  
}
export default connect(state => ({
  user: state.user,
}))(withRouter(SliderItems));
